<div class="bl-padding-sm--24 bl-text-align--center">
    <div class="bl-max-width--100 bl-margin-x--auto bl-margin-bottom--24">
      <img src="assets/images/Trash-icon.svg" alt="" aria-hidden="true">
    </div>
    <h4 class="bl-font-color--steel bl-font-weight--900 bl-margin-bottom--16">
      {{'jointApplicantRemoveModal/description' | dictionary}}
    </h4>
    <div
      class="bl-display--block bl-display-sm--flex bl-flex-direction--row-reverse bl-justify-content--center bl-width-sm--75 bl-margin-x--auto bl-margin-top--32">
      <button type="button" id="removeJoint" (click)="confirmDeleteApplicant()"
        class="bl-button bl-width--100 bl-margin-bottom--16 bl-margin-bottom-sm--0">{{'jointApplicantRemoveModal/confirm' | dictionary}}</button>
      <button type="button" id="custom-modal-close" data-dismiss="modal" (click)="cancelDeleteApplicant()"
        class="bl-button bl-button-reverse bl-margin-right--24 bl-width--100">{{'jointApplicantRemoveModal/cancel' | dictionary}}</button>
    </div>
  </div>